import Status from './status';

export default ({active, onClick, bonus}) => (
    <div className={`method-20 ${!active ? 'not-available' : ''}`} onClick={e => {
        if(!active)
            return;

        onClick({
            mode: "methods",
            method: "paypal-deposit"
        });
    }}>
        <div className="info">
            <div className="icon"> 
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_4299_7896)">
                        <rect width="36" height="36" rx="18" fill="#003087"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M19.5811 9H12.1755L9 24.2517H12.9308L14.0495 20.6665H19.5811C22.2792 20.6665 24.469 18.2498 24.469 15.2715V14.1943C24.469 11.2148 22.2792 9 19.5811 9ZM19.878 15.1016C19.878 16.3284 18.8448 17.3224 18.2475 17.3224L14.7703 17.3366L15.7583 12.4332H18.2475C18.8448 12.4332 19.878 13.4284 19.878 14.6551V15.1016Z" fill="white"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M25.802 13.5049C25.802 14.4193 25.7402 15.2518 25.7402 16.0106C25.7402 19.8238 24.1869 22.0719 20.7264 22.0719H15.6413L13.7756 27.8992H16.9096L18.0294 24.3116H23.1133C25.8126 24.3116 28.0001 22.2678 28.0001 19.3084V18.2373C28.0013 16.1864 27.3481 14.4062 25.802 13.5049Z" fill="white"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_4299_7896">
                            <rect width="36" height="36" fill="white"/>
                        </clipPath>
                    </defs>
                </svg>
            </div>

            <Status available={active} bonus={0} deposit_bonus={bonus} fee={0} />
        </div>

        <div className="name">PayPal</div>
    </div>
)